<template>
  <div>
    <!-- 월간교육일정표 -->
    <div v-show="menu === 0">
      <div class="cal">
        <div class="top-navi">
          <div
            v-for="(item, index) in navItem"
            :key="'topNavi' + index"
            :class="['top-navi__item', {selected: item.selected}]"
            @click="onClickNavItem(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="status-selector is-14m cursor" @click="seminarSelector.show = !seminarSelector.show">
          {{ seminarSelector.printName }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1601_8900)">
              <path
                d="M8.00048 8.78047L11.3005 5.48047L12.2431 6.42314L8.00048 10.6658L3.75781 6.42314L4.70048 5.48047L8.00048 8.78047Z"
                fill="#606060"
              />
            </g>
            <defs>
              <clipPath id="clip0_1601_8900">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <div v-show="seminarSelector.show" class="select-dropdown">
            <div class="is-14m" @click.stop.prevent="onClickSeminarSelector('01')">모든 일정 보기</div>
            <div class="is-14m" @click.stop.prevent="onClickSeminarSelector('02')">예정</div>
          </div>
        </div>
        <div>
          <div v-if="seminarSelector.type === '01'" class="calendar">
            <div id="calendar" style="margin-bottom: 24px" />
            <div class="is-14r">
              ※ (예정) 교육은 교육기간 및 일정 등 상황에 따라 변경되어 운영될 수 있습니다.<br />※ (종료) 교육은 종료된 과정입니다.
            </div>
          </div>
          <div v-else class="plan-table">
            <div class="plan-table__top">
              <div class="top-item">분야</div>
              <div class="top-item">주제</div>
              <div class="top-item">교육기간</div>
            </div>
            <div class="plan-table__list">
              <div class="plan-table__item" v-for="(item, index) in seminarListForPlan" :key="'planTable' + index" @click="goDetailPage(item)">
                <div class="table-item">{{ item.typeName }}</div>
                <div class="table-item">{{ item.title }}</div>
                <div class="table-item">{{ item.term }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 연간교육일정표 -->
    <div v-show="menu === 1" class="yearly">
      <div class="detail-title">
        <div class="ps-18r">파일 다운로드</div>
      </div>
      <div class="down-wrap">
        <div class="down-item" @click="onClickDownloadFile('excel')">
          <excel-icon />
          엑셀 형식 다운로드
        </div>
        <div class="down-item" @click="onClickDownloadFile('pdf')">
          <pdf-icon />
          PDF 형식 다운로드
        </div>
      </div>
    </div>
    <Spinner v-if="isSpinner" />
  </div>
</template>

<script>
import {convertDateForamt, getDate} from '~/utils/CommonUtils.js'
import {useSeminarStore} from '~/store/seminar/index.js'
import ExcelIcon from 'assets/svg/excel-icon.vue'
import PdfIcon from 'assets/svg/pdf-icon.vue'
import Spinner from '~/components/common/loading/Spinner.vue'

export default {
  name: 'SeminarTab1',
  components: {Spinner, PdfIcon, ExcelIcon},

  setup() {
    const store = useSeminarStore()
    return {store}
  },

  props: {
    menu: {
      type: Number,
      default: ''
    }
  },

  data() {
    return {
      isSpinner: false,
      agree: false,
      navItem: [
        {
          name: '전체과정',
          selected: false,
          type: ''
        },
        {
          name: '인사',
          selected: false,
          type: 'SMT01'
        },
        {
          name: '노무',
          selected: false,
          type: 'SMT02'
        },
        {
          name: 'HRD',
          selected: false,
          type: 'SMT03'
        },
        {
          name: '기타',
          selected: false,
          type: 'SMT04'
        }
      ],
      // 01 접수중, 02 예정
      seminarSelector: {
        type: '01',
        printName: '모든 일정 보기',
        show: false
      },
      seminarListForAccept: [
        {
          id: 0,
          title: '',
          start: '',
          end: ''
        }
      ],
      seminarListForPlan: [
        {
          id: 0,
          typeName: '',
          title: '',
          term: ''
        }
      ],
      calendar: null,
      calendarDate: getDate(0, 'YYYYMMDD'),
      seminarSearchInfo: {
        type: '',
        page: 1,
        limit: 100,
        status: '02'
      },
      filePath: {
        pdf: '',
        excel: '',
        image: ''
      },
      mailReceiver: {
        type: '01',
        action: 'C',
        companyName: '',
        department: '',
        name: '',
        position: '',
        receiverName: '',
        zipCode: '',
        address: '',
        addressDetail: ''
      }
    }
  },
  beforeUnmount() {
    // .custom-tooltip 클래스를 가진 요소를 모두 제거
    document.querySelectorAll('.custom-tooltip').forEach(tooltip => {
      tooltip.remove()
    })
  },
  watch: {
    menu(newVal) {
      if (newVal === 0) {
        // menu 값이 0이 되어 캘린더 관련 div가 DOM에 추가될 때
        // $nextTick을 사용하여 DOM 업데이트를 기다린 후 캘린더 초기화
        this.$nextTick(() => {
          this.onClickNavItem(this.navItem[0])
        })
      }
    }
  },
  async mounted() {
    await this.getSeminarFileList()
    if (this.$route.query.calendarDate) {
      this.calendarDate = this.$route.query.calendarDate
    }
    // 페이지 초기 로딩 시 menu가 1인 경우 캘린더 초기화
    if (this.menu === 0) {
      this.$nextTick(() => {
        this.onClickNavItem(this.navItem[0])
      })
    }
  },
  methods: {
    onClickCalendarBtn(type) {
      if (type === 'prev') {
        this.calendar.prev()
      } else if (type === 'next') {
        this.calendar.next()
      }
      // 캘린더에서 현재년월일을 구해온다
      const calendarDate = convertDateForamt(this.calendar.getCurrentData().currentDate, 'YYYYMMDD')
      // 쿼리에 calendarDate값에 넣어준다
      const newQuery = {...this.$route.query, calendarDate}
      this.$router.push({query: newQuery})
    },
    async getSeminarFileList() {
      try {
        const {data} = await this.store.getSeminarFileList()
        const files = data.files
        this.filePath = {
          pdf: files.find(file => file.type === 'pdf')?.path,
          excel: files.find(file => file.type === 'excel')?.path,
          image: files.find(file => file.type === 'image')?.path
        }
      } catch (error) {
        console.log(error)
      }
    },
    goDetailPage(item) {
      // 접수중일경우에만 이동
      if (item.status === '01') {
        this.$router.push(`/seminar/${item.id}`)
      }
    },
    // 이메일 데이터 입력
    inputData(type, value) {
      this.mailReceiver[type] = value
    },
    validateData() {
      const type = this.mailReceiver.type
      if (!this.mailReceiver.companyName) {
        alert('회사명을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.department) {
        alert('부서를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.name) {
        alert('성명을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.position) {
        alert('직위를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.receiverName) {
        alert('이름을 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.zipCode) {
        alert('우편번호를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.address) {
        alert('주소를 입력해주세요.')
        return false
      }
      if (!this.mailReceiver.addressDetail) {
        alert('세부주소를 입력해주세요.')
        return false
      }
      return true
    },
    async postSeminarMailApplication() {
      if (!this.validateData()) return
      try {
        this.isSpinner = true
        await this.store.postSeminarMailApplication(this.mailReceiver)
        alert('신청이 완료되었습니다.')
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSpinner = false
      }
    },
    // 교육과정 일정표 보기 방식
    onClickSeminarSelector(type) {
      this.seminarSelector.type = type
      this.seminarSelector.printName = type === '01' ? '모든 일정 보기' : '예정'
      this.seminarSelector.show = false

      if (this.seminarSelector.type === '01') {
        // '모든 일정 보기' 선택 시에도 $nextTick 적용
        this.$nextTick(() => {
          this.getMonthlySeminarList()
        })
      } else {
        this.getSeminarList()
      }
    },
    initCalendar() {
      // 캘린더 인스턴스가 이미 존재하면 파괴하고 다시 생성
      if (this.calendar) {
        this.calendar.destroy()
        this.calendar = null
      }

      const calendarEl = document.getElementById('calendar')
      // calendarEl이 null이 아닌지 다시 한 번 확인
      if (!calendarEl) {
        console.error('Calendar element not found!')
        return
      }

      this.calendar = new FullCalendar.Calendar(calendarEl, {
        events: this.seminarListForAccept,
        initialView: 'dayGridMonth',
        eventClick: this.handleEventClick,
        locale: 'ko',
        headerToolbar: {
          left: 'customPrev',
          center: 'title',
          right: 'customNext'
        },
        initialDate: this.calendarDate,
        titleFormat(date) {
          return date.date.year + '.' + String(date.date.month + 1).padStart(2, '0')
        },
        customButtons: {
          customPrev: {
            text: '<',
            click: () => {
              this.onClickCalendarBtn('prev') // 이전 달로 이동
            }
          },
          customNext: {
            text: '>',
            click: () => {
              this.onClickCalendarBtn('next') // 다음 달로 이동
            }
          }
        },
        eventMouseEnter: function (info) {
          // 툴팁 요소 생성
          const tooltip = document.createElement('div')
          tooltip.className = 'custom-tooltip'
          tooltip.innerText = info.event.title // 툴팁에 이벤트 제목 표시

          // 툴팁 스타일
          tooltip.style.position = 'absolute'
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.75)'
          tooltip.style.color = '#fff'
          tooltip.style.padding = '5px 10px'
          tooltip.style.borderRadius = '4px'
          tooltip.style.fontSize = '12px'
          tooltip.style.zIndex = '1000'
          tooltip.style.pointerEvents = 'none'

          // 현재 마우스 위치에 툴팁 배치
          document.body.appendChild(tooltip)
          info.el.addEventListener('mousemove', e => {
            tooltip.style.left = `${e.pageX + 10}px`
            tooltip.style.top = `${e.pageY + 10}px`
          })

          // 툴팁 DOM 요소 저장
          info.el.tooltipElement = tooltip
        },
        eventMouseLeave: function (info) {
          // 툴팁 제거
          if (info.el.tooltipElement) {
            document.body.removeChild(info.el.tooltipElement)
            delete info.el.tooltipElement
          }
        },
        eventDidMount: function (info) {
          // 이벤트 엘리먼트에 스타일 추가
          info.el.style.cursor = 'pointer'
        }
      })
      this.calendar.render()
    },
    handleEventClick(info) {
      this.$router.push(`/seminar/${info.event.id}`)
    },
    // pdf excel dow
    onClickDownloadFile(type) {
      window.open(this.filePath[type])
    },
    // 켈린더용 jsdelivr
    async getMonthlySeminarList() {
      // this.navItem 에서 selected true 인 것의 type을 가져와서 사용
      const type = this.navItem.find(item => item.selected).type
      try {
        this.isSpinner = true
        const {data} = await this.store.getMonthlySeminarList(type)
        this.seminarListForAccept = data

        // 캘린더가 seminarSelector.type이 '01'일 때만 존재하므로,
        // 이 조건이 충족될 때만 initCalendar를 호출합니다.
        if (this.seminarSelector.type === '01') {
          // 데이터를 받아온 후 $nextTick을 사용하여 캘린더 초기화
          this.$nextTick(() => {
            this.initCalendar()
            this.isSpinner = false
          })
        } else {
          this.isSpinner = false
        }
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      }
    },
    async getSeminarList() {
      try {
        this.seminarSearchInfo.type = this.navItem.find(item => item.selected).type
        const {data} = await this.store.getSeminarList(this.seminarSearchInfo)
        this.seminarListForPlan = data.list
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },

    onClickNavItem(item) {
      this.navItem.forEach(navItem => {
        navItem.selected = false
      })
      item.selected = true

      if (this.seminarSelector.type === '01') {
        // $nextTick으로 getMonthlySeminarList 호출
        this.$nextTick(() => {
          this.getMonthlySeminarList()
        })
      } else {
        this.getSeminarList()
      }
    }
  }
}
</script>
<style>
/* 날짜의 폰트 사이즈 설정 */
.fc-daygrid-day-top {
  font-size: 12px; /* 원하는 폰트 사이즈 */
}

.fc-col-header-cell-cushion {
  font-size: 14px;
}

/* 요일 헤더의 폰트 사이즈 설정 (선택 사항) */
.fc-day-header {
  font-size: 12px; /* 원하는 폰트 사이즈 */
}

.fc-daygrid-day-top,
.fc-col-header-cell-cushion {
  pointer-events: none;
}

/* 추가적으로 모든 transition 효과 제거 */
.fc * {
  transition: none !important;
}
</style>

<style scoped lang="scss">
// 월간
.cal {
  .top-navi {
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .top-navi__item {
      padding: 18px 16px;
      color: #606060;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 17.5px */
      cursor: pointer;

      &:hover {
        color: #0058aa;
      }

      &.selected {
        font-weight: 700;
        color: #0058aa;
        position: relative;

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 3px;
          background: #0058aa;
        }
      }
    }
  }

  .status-selector {
    display: flex;
    align-items: center;
    width: 118px;
    gap: 3px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #fff;
    justify-content: space-between;
    padding: 8px;
    margin-left: auto;
    margin-bottom: 16px;
    position: relative;

    .select-dropdown {
      width: 118px;
      position: absolute;
      left: 0;
      top: 40px;
      z-index: 2;
      background: #fff;
      display: flex;
      gap: 8px;
      padding: 8px;
      border: 1px solid #dbdbdb;
      flex-direction: column;
      border-radius: 4px;

      .is-14m {
        color: #909090;
        cursor: pointer;
      }
    }
  }
}

.plan-table {
  .plan-table__top {
    display: flex;
    border-bottom: 1px solid #909090;
    background: #fbfbfb;

    .top-item {
      padding: 12px 16px;
      font-size: 12px;
      font-weight: 500;

      &:first-child {
        width: 84px;
      }

      &:nth-child(2) {
        width: 480px;
      }

      &:last-child {
        width: 150px;
      }
    }
  }

  .plan-table__list {
    .plan-table__item {
      display: flex;
      border-bottom: 1px solid #dbdbdb;
      cursor: pointer;

      &:hover {
        background: #fbfbfb;
      }

      .table-item {
        font-size: 12px;
        font-weight: 400;
        padding: 16px;

        &:first-child {
          width: 84px;
        }

        &:nth-child(2) {
          width: 480px;
        }

        &:last-child {
          width: 150px;
          letter-spacing: -0.2px;
        }
      }
    }
  }
}

// 년간
.yearly {
  .top-banner {
    background: #0058aa;
    display: flex;
    width: 714px;
    padding: 8px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 170%; /* 23.8px */
    letter-spacing: -0.14px;
    margin-bottom: 16px;
  }

  .detail-title {
    margin-bottom: 24px;
  }

  .down-wrap {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;

    .down-item {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #121212;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      border-radius: 4px;
      border: 1px solid #dbdbdb;
      background: #fff;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
      padding: 8px 16px;
      cursor: pointer;

      &:hover {
        border: 1px solid #0058aa;
      }
    }
  }

  .receive-wrap {
    margin-bottom: 24px;

    .receive-title {
      color: #121212;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 170%; /* 23.8px */
      letter-spacing: -0.14px;
      margin-bottom: 12px;
    }
  }

  .notice-wrap {
    padding: 16px;
    border: 1px solid #dbdbdb;
    margin-bottom: 24px;
  }

  .sup-agree {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    margin-bottom: 24px;
  }

  .confirm-btn {
    color: #909090;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 125%; /* 20px */
    display: inline-flex;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #dbdbdb;
    background: #dbdbdb;
    pointer-events: none;

    &.agree {
      cursor: pointer;
      pointer-events: auto;
      background: #0058aa;
      color: #fff;
    }
  }
}
</style>
